import {
    LoadingNewsItemTitle,
    LoadingStyledIntro,
    LoadingItemHero
} from "../../../utils/loading-styles";

export const LoadingNewsItem = () => {

    return (
        <>
            <LoadingItemHero>
                &nbsp;
            </LoadingItemHero>

            <LoadingNewsItemTitle><h2>&nbsp;</h2></LoadingNewsItemTitle>
            <LoadingStyledIntro>
            <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
            </LoadingStyledIntro>
        </>
    )
}
